import { schema } from 'normalizr';

const service = new schema.Entity('service');

export default service;
